module.exports = "/packs/images/homepage/facilities/careers~aef32384a36225d75a17ae29216cf0da.jpg";